import React, {FC, memo} from "react";
import {AccessoriesListProps} from "./AccessoriesList-types";
import {Item, Root} from "./AccessoriesList-styles";
import Checkbox from "../Checkbox/Checkbox";
import {generateUid, splitUid} from "../../utils/ApplicationUtils";
import {useRecoilValue} from "recoil";
import {stateSelectedAccessories} from "../../data/atoms";
import {arraysIntersection} from "../../utils/ArrayUtils";


const AccessoriesList: FC<AccessoriesListProps> = memo((props) => {
    const {accessories, onAccessoireSelect} = props;

    const selected = useRecoilValue(stateSelectedAccessories);
    const selectedAccessoriesIds =  Object.keys(selected).map(uid => splitUid(uid)[0]);

    return (
        <Root>
            {
                accessories.map((accessoire) => {
                    const uid = generateUid(accessoire.id, accessoire.attributes[0].id);

                    if (
                        accessoire.dependsOnIds != null &&
                        arraysIntersection(accessoire.dependsOnIds, selectedAccessoriesIds).length === 0
                    ) {
                        return null;
                    }

                    return (
                        <Item key={accessoire.id}>
                            <Checkbox
                                id={uid}
                                value={uid}
                                text={accessoire.title}
                                isChecked={selected.hasOwnProperty(uid)}
                                onClick={onAccessoireSelect}/>
                        </Item>
                    )
                })
            }
        </Root>
    )
});

export default AccessoriesList;
